import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {CurrencyService} from '../../general-services/service-currency-anagraf/currency.service';
import {CurrencyModel} from '../../../models/CurrencyModel';
import * as toastr from 'toastr';
import {RegionModel} from '../../../models/RegionModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {Router} from '@angular/router';
import {LoaderService} from '../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-currency-anagraf',
  templateUrl: './currency-anagraf.component.html',
  styleUrls: ['./currency-anagraf.component.scss']
})
export class CurrencyAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  filter: CurrencyModel;
  filterAllInSettings: AllSettingsFilterModel;
  selectedRowIndex: number;
  displayedColumns: Array<string>;
  dataSource: any;
  currencyUrl: string;
  isMocked: boolean;
  isAnagraphSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;


  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() idSelected?: number;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Output() elementSelected = new EventEmitter();


  constructor(private currencyService: CurrencyService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.currencyUrl = servers.apiUrl + urls.cobidbService + urls.currency;
    this.showActions = true;
    this.selectedRowIndex = -1;
    this.filter = new CurrencyModel();
    this.inAllSettings = false;
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('regionForFilterInSettings' in changes ||
      'contractTypeForFilterInSettings' in changes ||
      'resourceUnitForFilterInSettings' in changes ||
      'localCustomerForFilterInSettings' in changes ||
      'designServicesForFilterInSettings' in changes ||
      'providerForFilterInSettings' in changes) {
      this.resetTable();
    }
  }

  ngOnInit() {
    this.isMocked = false;
    if (this.showActions) {
      this.displayedColumns = ['currencyCod', 'currencyDesc', 'inCurrencySetting', 'actions'];
    } else {
      this.selectedRowIndex = this.idSelected;
      this.displayedColumns = ['currencyCod', 'currencyDesc'];
    }
    this.pageSize = 10;
    this.setOffsetInSession();
    this.getAll(this.offset);
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.isMocked) {
      this.listData = new MatTableDataSource(this.dataSource);
      this.listData.paginator = this.paginator;
      this.listData.sort = this.sort;
    } else {
      if (this.inAllSettings) {
        this.filterAllInSettings = new AllSettingsFilterModel();

        this.filterAllInSettings.region = this.regionForFilterInSettings;
        this.filterAllInSettings.resourceUnit = this.resourceUnitForFilterInSettings;
        this.filterAllInSettings.localCustomer = this.localCustomerForFilterInSettings;
        this.filterAllInSettings.provider = this.providerForFilterInSettings;
        this.filterAllInSettings.contractType = this.contractTypeForFilterInSettings;
        this.filterAllInSettings.currency = this.filter;

        this.getPageSubscribe = this.currencyService.getPageInAllSettings(offset, this.filterAllInSettings)
          .subscribe(
            (result: any) => {
              this.dataSource = result.content;
              this.listData = new MatTableDataSource(this.dataSource);
              this.paginator.pageIndex = offset.pageIndex;
              this.paginator.showFirstLastButtons = true;
              this.paginator.length = result.totalElements;
              this.loaderService.display(false);
            });
      } else {
        this.getPageSubscribe = this.currencyService.getPage(offset, this.filter)
          .subscribe(
            (result: any) => {
              this.dataSource = result.content;
              this.listData = new MatTableDataSource(this.dataSource);
              this.paginator.pageIndex = offset.pageIndex;
              this.paginator.showFirstLastButtons = true;
              this.paginator.length = result.totalElements;
              this.loaderService.display(false);
            });
      }
    }
  }

  filterTable() {
    this.getAll(this.offset);
  }

  resetTable() {
    this.filter = new CurrencyModel();
    this.getAll(new Offset(10, 0));
  }
  openDialog(id: number) {
    const currencyData = this.dataSource.find(data => data.id === id) as CurrencyModel;
    const list: GenericArray[] = [
      { id: 'Currency Cod', value: currencyData.cod.toString()},
      { id: 'Currency Description', value: currencyData.description.toString()}
      ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.currencyService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Currency with id ' + id + ' was deleted with success', 'Success');
              this.getAll(this.offset);
            } else {
              toastr.info('Currency cannot be deleted', 'Alert');
            }
          }, error => {
            toastr.error('Currency with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    console.log(dataFiltered);
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('currencyOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('currencyOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
      this.pageSize = this.offset.pageSize;
    }
  }
}
